module.exports = {
	DOM_CLASS_TIPSUCCESS: 'tip-success',
	DOM_CLASS_SPIN: 'spin',
	DOM_SELECTOR_SENDMESSAGEBTN: '#ls-send-message',
	DOM_SELECTOR_SENDGIFTBTN: '#toggle-gift-box',
	DOM_SELECTOR_VOLUMEBTN: '#volume-change',
	DOM_SELECTOR_FULLSCREEN: '#toggle-fullscreen',

	EVENT_LIVESHOWISOVER: 'liveshow_is_over',

	TIMER_THANKYOU: 5000,
	TIMER_WAIT_FOR_DONE: 1000 * 2,

	fm: {
		MARGIN_PLAYER_H: 75,
		MARGIN_PLAYER_W: 300
	},

	STATUS_CONNECTED: 'connected',
	STATUS_DISCONNECTED: 'disconnected',

	ERROR_EMPTY_BALANCE: 'empty.balance',

	MUTE_MESSAGE: 'muted you. You won\'t be able to chat during this show until you are unmuted.',
	UNMUTE_MESSAGE: 'has unmuted you. You can now use chat during the show.',

	BLOCK_MESSAGE: 'has blocked you from viewing this show.',
	UNBLOCK_MESSAGE: 'has unblocked you. You can now watch the show.'
};


// WEBPACK FOOTER //
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/site/root/components/liveshow/widget/mixins/constants.es.js